import React from 'react';
import { NumericInput, Tooltip, Position, Icon } from '@blueprintjs/core';
import find from 'lodash/find';
import cloneDeep from 'lodash/cloneDeep';
import {
  TypeSection,
  Score,
  TypeInfo,
  Container,
  NoScore,
} from 'components/vendor-requests/styled-score-components';
import { IconNames } from '@blueprintjs/icons';

const updateValueInObject = (collection, id, value, update) => {
  const coll = cloneDeep(collection);
  const obj = find(coll, ['questionnaireScoreID', id]);

  if (value > 100) {
    obj.score = 100;
  } else if (value > 0 && value <= 100) {
    obj.score = value.replace(/^0+/, '');
  } else {
    obj.score = 0;
  }
  update(coll);
};

const TypeContainer = ({
  score,
  editing,
  stateScores,
  handleUpdateScores,
  propertyKey,
  scoresLoaded,
  modifyAll
}) => {

  return (
    <TypeSection>
      <Score>Score</Score>
      <TypeInfo>
        <span>{score[propertyKey]}</span>
        {editing && scoresLoaded ? (
          <div
            style={{
              width: '40%',
              margin: '0 -0.25rem 0 0.75rem',
              minWidth: '100px',
            }}
          >
            <NumericInput
              disabled = {!modifyAll}
              max={100}
              min={0}
              value={
                find(stateScores, [
                  'questionnaireScoreID',
                  score.questionnaireScoreID,
                ]).score
              }
              onValueChange={(number, string) =>
                updateValueInObject(
                  stateScores,
                  score.questionnaireScoreID,
                  string,
                  handleUpdateScores
                )
              }
              onButtonClick={(number, string) =>
                updateValueInObject(
                  stateScores,
                  score.questionnaireScoreID,
                  string,
                  handleUpdateScores
                )
              }
              large
              fill
            />
          </div>
        ) : (
          <span style={{ marginLeft: '10px', fontWeight: 700 }}>
            {score.score}%
          </span>
        )}
      </TypeInfo>
    </TypeSection>
  );
};

const Scores = ({
  editing,
  scores,
  stateScores,
  handleUpdateScores,
  title,
  propertyKey,
  scoresLoaded,
  direction,
  justify,
  modifyAll
}) => {
  return (
    <Container direction={direction} justify={justify}>
      {scores.length ? (
        <div style={{ display: 'flex' }}>
          {title}

          <Tooltip
            content={
              <>
                These are the scores for each question type.
                <br />
                They are used to determine if the Third Party
                <br />
                user passes or fails the questionnaire.
              </>
            }
            position={Position.TOP}
          >
            <Icon icon={IconNames.INFO_SIGN} style={{ marginLeft: '1rem' }} />
          </Tooltip>
        </div>
      ) : null}

      {scoresLoaded && scores.length ? (
        scores.map(score => (
          <TypeContainer
            key={score.questionnaireScoreID}
            score={score}
            editing={editing}
            stateScores={stateScores}
            handleUpdateScores={handleUpdateScores}
            propertyKey={propertyKey}
            scoresLoaded={scoresLoaded}
            modifyAll={modifyAll}
          />
        ))
      ) : (
        <NoScore>The questionnaire has not yet been scored.</NoScore>
      )}
    </Container>
  );
};

export default Scores;
